import { render, staticRenderFns } from "./DetailPenjualan.vue?vue&type=template&id=4c699ce0&"
import script from "./DetailPenjualan.vue?vue&type=script&lang=js&"
export * from "./DetailPenjualan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports